import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from 'src/auth/auth-context';
import BaseButton from 'src/common/components/base-button';
import { ILoginUser } from 'src/common/interfaces/dtos/ILoginUser';
import { newStyles as loginStyles } from '../touchpoint/components/login-emerald-styles';

const IAMLoginButton: React.FC<IAMProps> = (props: IAMProps) => {
  /*
        Component just renders a button that will take you to edge sign in
    */

  const { t } = useTranslation();
  const classes = loginStyles();
  const { loading, signinPopup } = useAuthContext();

  const showIAMPopup = () => {
    if (!loading) {
      signinPopup(true).then(async user => {
        /*
           After edge has done its sign in and authentication
           handle any other logic with conditionals here
           if needing to do more than the basic login flow
          */
        props.handleIAMLogin({
          sessionId: user.access_token,
        });
      });
    }
  };

  return (
    <>
      <BaseButton
        data-testid='edge-login-button'
        buttonType='primary'
        className={`${classes.bluebutton} ${classes.buttonwhitefont} ${classes.iamButton}`}
        fullWidth
        onClick={showIAMPopup}
      >
        {t('SignIn')}
      </BaseButton>
    </>
  );
};

// Add more to the props for different scenarios other than basic login
interface IAMProps {
  handleIAMLogin: (iamUser: ILoginUser) => void;
}

export default IAMLoginButton;
